<template>
  <div id="app">
    <div id="background-loading" v-show="isLoading">
      <vue-loader name="ball-clip-rotate-multiple"
                  color="#333"
                  size="50px"
                  class="custom-loader"
      ></vue-loader>
    </div>
    <nav-bar v-if="user.id" :user="user" />
    <div class="container-fluid">
      <router-view/>
    </div>
    <footer-dimabe v-if="user.id" :user="user"/>
  </div>
</template>

<style>
  @import '../public/dimabe-style.css';
</style>

<script>
import NavBar from './views/NavBar.vue';
import FooterDimabe from './views/Footer.vue';
export default {
  components: {
    NavBar,
    FooterDimabe
  },
  computed:  {
    user() {
      return this.$store.getters.user
    },
    isLoading() {
      return this.$store.getters.loading
    }
  }
}
</script>
